import { styled } from '../jss-style';
import tabsStyle from './tabs';

const useTabsStyle = styled(tabsStyle, 'tabs');
export { tabsStyle, useTabsStyle };
export default useTabsStyle;
